<template>
  <form-inline
    :outdated="attempt.replaced_by_proposal_attempt_id"
    :current="attempt.obs"
    :loading="loading"
    :class="classes"
    @submit="submit"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import FormInline from '@cordel/components/Form/Inline.vue';

  export default {
    name: 'ProposalsReadNote',
    components: {
      FormInline,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      attempt: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapState([
        'proposalAttempts',
      ]),
      loading() {
        return this.proposalAttempts.update.loading;
      },
      classes() {
        const classes = ['proposals-read-note'];

        if (this.attempt.replaced_by_proposal_attempt_id) {
          classes.push('outdated-label-class');
        }

        return classes;
      },
    },
    mounted() {
      this.$store.dispatch('proposalAttempts/clear', {
        action: 'update',
      });
    },
    methods: {
      submit(note) {
        if (!note) {
          return;
        }

        this.$store.dispatch('proposalAttempts/update', {
          proposal_id: this.proposal.id,
          id: this.attempt.id,
          obs: note,
        });
      },
    },
  };
</script>

<style lang="scss">
  .proposals-read-note {
    .cordel-inline-input {
      flex: 1;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-note {
  }

  .outdated-label-class {
    color: var(--cordel-color-neutral-primary);
  }
</style>
